import React from 'react';
import type { ContatoData } from 'volto-ministerio-publico-federal/components/types';
import {
  MPFButton,
  MPFLink,
} from 'volto-ministerio-publico-federal/components/UI';

interface UnidadeContatoProps {
  content: {
    '@components'?: {
      contato?: {
        data?: ContatoData;
      };
    };
  };
}

const UnidadeContato: React.FC<UnidadeContatoProps> = ({ content }) => {
  const data = content?.['@components']?.contato?.data ?? {};

  return (
    <section className="mpf-contato-view">
      <article className="mpf-contato-view__main">
        <header className="mpf-contato-view__header">
          <h1 className="mpf-contato-view__title">
            Informações sobre a unidade
          </h1>
        </header>
        {data.contato && (
          <div className="mpf-contato-view__section">
            <h2 className="mpf-contato-view__section-title">Contato</h2>
            <div
              className="mpf-contato-view__editor-content"
              dangerouslySetInnerHTML={{
                __html: data.contato.data,
              }}
            />
          </div>
        )}
        {data.endereco && (
          <div className="mpf-contato-view__section">
            <h2 className="mpf-contato-view__section-title">Endereço</h2>
            <div
              className="mpf-contato-view__editor-content"
              dangerouslySetInnerHTML={{
                __html: data.endereco.data,
              }}
            />
          </div>
        )}
        {data.como_chegar && (
          <div className="mpf-contato-view__section">
            <h2 className="mpf-contato-view__section-title">Como chegar</h2>
            <div
              className="mpf-contato-view__editor-content"
              dangerouslySetInnerHTML={{
                __html: data.como_chegar.data,
              }}
            />
          </div>
        )}
      </article>
      <aside className="mpf-contato-view__sidebar">
        <div className="mpf-contato-view__cta-card">
          <h3 className="mpf-contato-view__cta-title">
            Precisa de atendimento?
          </h3>
          <p className="mpf-contato-view__cta-text">
            Acesse canais oficiais ou veja os principais serviços ao cidadão.
          </p>
          <MPFButton
            as={MPFLink}
            href="/servicos"
            variant="unstyled"
            className="mpf-contato-view__cta-button"
          >
            Ver serviços
          </MPFButton>
        </div>
      </aside>
    </section>
  );
};

export default UnidadeContato;
